<template>
  <div>
    <!-- add event modal  -->
    <!-- dialog -->
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <div
          class="close-btn"
          :class="locale == 'en' ? 'text-right' : 'text-left'"
        >
          <v-btn color text @click="closeDialog()">
            <v-icon class="main-color">close</v-icon>
          </v-btn>
        </div>
        <v-card-title class="headline main-color">{{
          $t("Add Group Session")
        }}</v-card-title>
        <p class="error--text text-center">{{ errorMsg }}</p>
        <div>
          <v-container>
            <div v-if="scheduleMessage != ''" style="text-align: center">
              <p class="alert" style="color: red">{{ scheduleMessage }}</p>
            </div>
            <v-form v-model="valid" ref="form">
              <v-row>
                <!-- <v-col cols="12" sm="6" class="py-0">
                  <v-menu
                    v-model="menu3"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <label for="date">{{ $t("theDate") }} *</label>
                      <v-text-field
                        v-model="event.date"
                        prepend-inner-icon="event"
                        :rules="[validationRules.required]"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        solo
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="event.date"
                      @input="menu3 = false"
                      :min="nowDate"
                    ></v-date-picker>
                  </v-menu>
                </v-col> -->

                <v-col cols="12" sm="6" class="py-0">
                  <label for="Grade">{{ $t("Grade") }} *</label>
                  <v-select
                    v-model="selectedGrade"
                    @change="getGradeSubjects"
                    :items="grades"
                    :rules="[validationRules.required]"
                    item-text="name"
                    item-value="id"
                    solo
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" class="py-0">
                  <label for="subject">{{ $t("Subject") }} *</label>
                  <v-select
                    v-model="selectedSubject"
                    @change="getSubjectLanguages"
                    :items="subjects"
                    :rules="[validationRules.required]"
                    item-text="name"
                    item-value="id"
                    solo
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" class="py-0">
                  <label for="Language">{{ $t("Language") }} *</label>
                  <v-select
                    v-model="selectedLanguage"
                    :items="languages"
                    :rules="[validationRules.required]"
                    item-text="name"
                    item-value="id"
                    solo
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6" class="py-0">
                  <label for="duration">{{ $t("repeatAppointment") }} *</label>

                  <v-select
                    v-model="event.repeat_for"
                    @change="makeRepeatedLessons(event.repeat_for)"
                    :items="durations"
                    item-text="text"
                    item-value="num"
                    solo
                  ></v-select>
                </v-col>

                <v-col class="py-0" cols="12">
                  <v-alert colored-border type="info"
                    >{{
                      $t(
                        "If minimum number not reached 24 hours earlier, session will be automatically canceled"
                      )
                    }}
                  </v-alert>
                </v-col>
                <v-col cols="12" sm="6" class="py-0">
                  <v-checkbox
                    class="mt-7"
                    v-model="setMinStudents"
                    @change="toggleMinStudents"
                    :label="$t('Minimum number of students')"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="6" class="py-0">
                  <label for="Title">{{ $t("Number of students") }}:</label>
                  <v-text-field
                    v-model="numberOfStudents"
                    solo
                    :rules="[
                      validationRules.numeric,
                      positiveNumber(numberOfStudents),
                      validationRules.minValue2,
                      validationRules.maxValue100,
                    ]"
                    :disabled="!setMinStudents"
                  ></v-text-field>
                </v-col>

                <v-row
                  class="mx-0"
                  v-for="(lesson, index) in lessons"
                  :key="index"
                >
                  <v-col cols="12">
                    <hr />
                  </v-col>

                  <v-col cols="12" sm="6" class="py-0">
                    <label for="Title">{{ $t("Lesson") }}:</label>
                    <v-text-field
                      v-model="lesson.lesson_name"
                      :rules="[validationRules.required]"
                      solo
                    ></v-text-field>
                  </v-col>

                  <!-- date input for every session -->
                  <v-col cols="12" sm="6" class="py-0">
                    <groupDateComponent
                      :index="index"
                      @setDateValue="setDateValue"
                    />
                  </v-col>
                  <!-- from input -->
                  <v-col cols="12" sm="6" class="py-0">
                    <groupFromTimeComponent
                      :index="index"
                      :DefaultFrom="DefaultFrom"
                      type="start"
                      @setFromValue="setFromValue"
                    />
                  </v-col>

                  <!-- to input -->
                  <v-col cols="12" sm="6" class="py-0">
                    <groupFromTimeComponent
                      :index="index"
                      type="end"
                      @setToValue="setToValue"
                    />
                  </v-col>

                  <v-col
                    cols="12"
                    sm="12"
                    class="py-0 text-center "
                    v-if="validationError[index] != false"
                  >
                    <p class="validation-error red--text mb-0">
                      {{ validationError[index] }}
                    </p>
                  </v-col>

                  <v-col cols="12" sm="6" class="py-0">
                    <label for="Fees">{{ $t("Fees") }}:</label>
                    <v-text-field
                      v-model="lesson.lesson_fees"
                      :rules="[
                        validationRules.required,
                        validationRules.numeric,
                        validationRules.positiveNumber,
                      ]"
                      solo
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    sm="6"
                    class="py-0"
                    v-if="index == 0 && lessons.length > 1"
                  >
                    <div class="d-flex repeat-time-fees">
                      <v-checkbox
                        v-model="repeatTime"
                        :label="$t('Repeat Time')"
                        @change="makeRepeatTime"
                      ></v-checkbox>
                      <v-checkbox
                        v-model="repeatFees"
                        @change="makeRepeatFees"
                        :label="$t('Repeat Fees')"
                      ></v-checkbox>
                    </div>
                  </v-col>
                </v-row>
              </v-row>
            </v-form>
          </v-container>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="modal-btn text-center">
            <v-btn class="primary-btn" text @click="saveEvent">{{
              $t("save")
            }}</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";

import { validationMixin } from "../../mixins/validationMixin";
import groupFromTimeComponent from "../../components/teacherAppointments/groupFromTimeComponent";
import groupDateComponent from "../../components/teacherAppointments/groupDateComponent";
import Vue from "vue";

export default {
  name: "groupAppointmentDialog",
  mixins: [validationMixin],
  components: { groupFromTimeComponent, groupDateComponent },
  props: ["dialog"],
  data() {
    return {
      setMinStudents: false,
      numberOfStudents: "",
      errorMsg: "",
      validationError: [],
      repeatTime: false,
      repeatFees: false,
      DefaultFrom: "",
      DefaultFees: "",
      valid: false,
      // menu3: false,

      scheduleMessage: "",

      event: {
        start: null,
        end: null,
        date: new Date().toISOString().substr(0, 10),
        repeat_for: "1",
      },

      durations: [
        { text: this.$i18n.t("Withoud Repeat"), num: "1" },
        { text: this.$i18n.t("One Week"), num: "2" },
        { text: this.$i18n.t("Two Weeks"), num: "3" },
        { text: this.$i18n.t("Three Weeks"), num: "4" },
        { text: this.$i18n.t("Four Weeks"), num: "5" },
        { text: this.$i18n.t("Five Weeks"), num: "6" },
        { text: this.$i18n.t("Six Weeks"), num: "7" },
        { text: this.$i18n.t("Seven Weeks"), num: "8" },
        { text: this.$i18n.t("Eight Weeks"), num: "9" },
        { text: this.$i18n.t("Nine  Weeks"), num: "10" },
        { text: this.$i18n.t("Ten Weeks"), num: "11" },
      ],
      nowDate: new Date(Date.now()).toISOString().slice(0, 10),
      grades: [],
      selectedGrade: "",
      subject: [],
      selectedSubject: "",
      subjects: [],
      lessons: [],
      languages: [],
      selectedLanguage: "",
    };
  },
  // watch: {
  //   lessons: {
  //     handler() {

  //     },
  //     deep,
  //   },
  // },
  methods: {
    toggleMinStudents() {
      if (this.setMinStudents == false) {
        this.numberOfStudents = "";
      }
    },
    closeDialog() {
      this.resetValidation();
      this.$emit("closeGroupDialog");
    },
    startTimeRule(start, end, str) {
      if (start && end) {
        const startTime = moment(start, "HH:mm");
        const endTime = moment(end, "HH:mm");
        return startTime >= endTime ? str : false;
        // console.log("error");
      }
    },
    // checkMinMaxValidation(index) {},
    setDateValue(index, dateValue) {
      this.lessons[index].date = dateValue;
    },
    getGrades() {
      this.$http
        .get(this.getApiUrl + "/teacher/grades", {
          headers: {
            locale: localStorage.locale,
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.grades = response.data.data;
        });
    },
    getGradeSubjects() {
      this.selectedSubject = "";
      this.selectedLanguage = "";
      this.$http
        .get(
          this.getApiUrl + "/teacher/getTeachersubjects/" + this.selectedGrade,
          {
            headers: {
              locale: localStorage.locale,
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then((response) => {
          this.subjects = response.data.data;
        });
    },

    getSubjectLanguages() {
      this.selectedLanguage = "";
      this.$http
        .get(
          this.getApiUrl +
            "/teacher/getLanguageofsubjects/" +
            this.selectedSubject,
          {
            headers: {
              locale: localStorage.locale,
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then((response) => {
          this.languages = response.data.data;
        });
    },
    makeRepeatTime() {
      if (this.lessons[0].start && this.repeatTime) {
        const defaultStart = this.lessons[0].start;
        this.DefaultFrom = defaultStart;
        this.lessons.forEach((lesson, index) => {
          lesson.start = defaultStart;
        });
      } else {
        this.DefaultFrom = "";
        this.lessons.forEach((lesson, index) => {
          lesson.start = "";
        });
      }
    },
    makeRepeatFees() {
      // repeatFees
      if (this.lessons[0].lesson_fees && this.repeatFees) {
        const defaultFees = this.lessons[0].lesson_fees;
        this.DefaultFees = defaultFees;
        this.lessons.forEach((lesson, index) => {
          lesson.lesson_fees = defaultFees;
        });
      } else {
        this.DefaultFees = "";
        this.lessons.forEach((lesson, index) => {
          if (index > 0) {
            lesson.lesson_fees = "";
          }
        });
      }
    },
    setFromValue(index, fromValue) {
      this.lessons[index].start = fromValue;
      const checkValue = this.startTimeRule(
        this.lessons[index].start,
        this.lessons[index].end,
        this.$i18n.t("End time must be more than start time")
      );
      Vue.set(this.validationError, index, checkValue);
    },
    setToValue(index, ToValue) {
      this.lessons[index].end = ToValue;

      // this.validationError[index]
      const checkValue = this.startTimeRule(
        this.lessons[index].start,
        this.lessons[index].end,
        this.$i18n.t("End time must be more than start time")
      );
      Vue.set(this.validationError, index, checkValue);
    },

    saveEvent() {
      if (this.valid) {
        // make group session object
        const GroupSession = {};
        GroupSession.selectedGrade = this.selectedGrade;
        GroupSession.selectedSubject = this.selectedSubject;
        GroupSession.selectedLanguage = this.selectedLanguage;
        GroupSession.minmum_number_of_student = this.numberOfStudents;

        GroupSession.lessons = this.lessons;

        this.$http
          .post(this.getApiUrl + "/teacher/schedule/saveGroup", GroupSession, {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              locale: this.locale,
            },
          })
          .then((response) => {
            console.log(response);
            if (response.data.status.error == true) {
              this.errorMsg = response.data.status.message;
            } else {
              this.$emit("showSnack");
              this.$emit("getEvent");
              this.closeDialog();
            }
          });
      } else {
        this.validate();
      }
    },

    makeRepeatedLessons(repeatNum) {
      this.lessons = [];
      this.menus = [];
      const repeatObj = {
        lesson_name: "",
        date: "",
        start: "",
        end: "",
        lesson_fees: "",
      };
      for (let index = 1; index <= repeatNum; index++) {
        this.lessons[index - 1] = { ...repeatObj };
        this.menus.push(false);
      }

      // reset defualt FromValue
      this.repeatTime = false;
      this.DefaultFrom = "";
      // reset defualt FeesValue
      this.DefaultFees = "";
      this.repeatFees = false;
    },
  },
  mounted() {
    this.getGrades();
    this.lessons[0] = {
      lesson_name: "",
      date: "",
      start: "",
      end: "",
      lesson_fees: "",
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/_variables.scss";
@import "../../assets/styles/_responsive.scss";

.repeat-time-fees {
  height: 100%;
  align-items: center !important;
}

.v-alert {
  padding-bottom: 10px;
  border: 1px solid #ccc;
}
</style>
